import { useTranslation } from "react-i18next";
import { cmsUrl } from "@kozien/shared";
import { TypeCard } from "@/components/molecules/TypeCard/TypeCard";
import { VideoHelpSection } from "@/components/organisms/VideoHelpSection/VideoHelpSection";
import { useSelectionStore } from "@/store/selection";
import { useSunProtectionPageContent } from "@/models/sun-protection-settings";
import type { ProductType } from "@/models/product";

export function CategoryStep() {
    const { t } = useTranslation();
    const { selectedCategory, selectCategory } = useSelectionStore();
    const { data: pageContent } = useSunProtectionPageContent();
    const cms = pageContent?.decorationTypeStep ?? null;

    const title = cms?.title ?? t("categoryStep.title");
    const subtitle = cms?.content ?? t("categoryStep.subtitle");

    const sunProtectionImageUrl =
        cmsUrl(
            cms?.sunProtectionImage?.url,
            import.meta.env.VITE_CMS_BASE_ENDPOINT,
        ) ?? null;
    const windowDecorationImageUrl =
        cmsUrl(
            cms?.windowDecorationImage?.url,
            import.meta.env.VITE_CMS_BASE_ENDPOINT,
        ) ?? null;

    type Option = {
        id: ProductType;
        name: string;
        subtitle: string | null;
        imageUrl: string | null;
    };

    const options: Option[] = [
        {
            id: "SUN_PROTECTION",
            name: t("categoryStep.sunProtection.name"),
            subtitle:
                cms?.sunProtectionDescription ??
                t("categoryStep.sunProtection.subtitle"),
            imageUrl: sunProtectionImageUrl,
        },
        {
            id: "WINDOW_DECORATION",
            name: t("categoryStep.windowDecoration.name"),
            subtitle:
                cms?.windowDecorationDescription ??
                t("categoryStep.windowDecoration.subtitle"),
            imageUrl: windowDecorationImageUrl,
        },
    ];

    return (
        <div className="flex flex-col gap-6">
            <div className="text-center">
                <h1 className="text-3xl font-bold text-gray-900 leading-tight">
                    {title}
                </h1>
                <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
                    {subtitle}
                </p>
            </div>

            <div className="grid grid-cols-2 gap-4 justify-center sm:grid-cols-[repeat(auto-fit,minmax(220px,280px))]">
                {options.map((opt) => (
                    <TypeCard
                        key={opt.id}
                        id={opt.id}
                        name={opt.name}
                        subtitle={opt.subtitle}
                        imageUrl={opt.imageUrl}
                        selected={selectedCategory === opt.id}
                        onClick={() => selectCategory(opt.id)}
                    />
                ))}
            </div>

            <VideoHelpSection section={cms?.videosSection} />
        </div>
    );
}
